<template>
  <div class="productDescList" :class="{ 'productDescList--hidden': isHidden }">
    <div ref="productDescListInner" class="productDescList__inner">
      <editor-product-sections :blocks="list" />
      <div v-if="isHidden" class="productDescList__overlay">
        <button class="productDescList__overlayButton" @click="isHidden = false">
          ZOBACZ PEŁEN OPIS
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import EditorProductSections from '~/components/Editor/Product/EditorProductSections';

export default {
  name: 'ProductDescList',
  components: { EditorProductSections },
  props: {
    list: {
      type: [Array, Object],
      default: () => {},
    },
  },
  data() {
    return {
      isHidden: false,
    };
  },
  mounted() {
    this.checkHeight();
  },
  methods: {
    checkHeight() {
      this.isHidden = this.$refs.productDescListInner.clientHeight > 600;
    },
  },
};
</script>

<style lang="scss">
.productDescList {
  $root: &;
  position: relative;

  &__overlay {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 14rem;
    width: 100%;
    background-image: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff 59%, #ffffff 100%);
    opacity: 0;
    pointer-events: none;
  }

  &__overlayButton {
    position: absolute;
    left: 50%;
    bottom: 0;
    padding: 4px 0;
    transform: translateX(-50%);
    font-size: 1.2rem;
    line-height: 1.5rem;
    letter-spacing: 0.05em;
    font-weight: 900;
    color: $cMain;

    &:before {
      content: '';
      position: absolute;
      left: 50%;
      bottom: 0;
      width: 100%;
      transform: translateX(-50%);
      height: 2px;
      background-color: $cMain;
      transition: width $tr;
    }

    &:hover {
      &:before {
        width: 50%;
      }
    }
  }

  &--hidden {
    max-height: 650px;
    overflow: hidden;

    #{$root}__overlay {
      opacity: 1;
      pointer-events: all;
    }
  }
}
</style>
